"use strict";

/* eslint-disable global-require */
var add = require('./helpers/add');
var aid = require('./helpers/aid');
var compare = require('./helpers/compare');
var currencyFormat = require('./helpers/currencyFormat');
var dateFormat = require('./helpers/dateFormat');
var define = require('./helpers/define');
var ifAll = require('./helpers/ifAll');
var ifAny = require('./helpers/ifAny');
var math = require('./helpers/math');
var ordinal = require('./helpers/ordinal');
var partial = require('./helpers/partial');
var percentageFormat = require('./helpers/percentageFormat');
var phoneFormat = require('./helpers/phoneFormat');
var subtract = require('./helpers/subtract');
var times = require('./helpers/times');
var jsonString = require('./helpers/jsonString');

/**
 * Load all Handlerbars helpers when the package is imported
 *
 * @param {Function} Handlebars
 * @param {Boolean} to disable client side helpers, it is useful for when the build is created by gulp or unit test
 */

function handlebarsHelpers(Handlebars) {
  var disableClientSideHelpers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var activeHelpers = {
    add: add,
    aid: aid,
    compare: compare,
    currencyFormat: currencyFormat,
    dateFormat: dateFormat,
    define: define,
    ifAll: ifAll,
    ifAny: ifAny,
    math: math,
    ordinal: ordinal,
    partial: partial,
    percentageFormat: percentageFormat,
    phoneFormat: phoneFormat,
    subtract: subtract,
    times: times,
    jsonString: jsonString
  };
  if (!disableClientSideHelpers) {
    activeHelpers.defineModule = require('./helpers/defineModule');
    activeHelpers.dynamicModuleRegistryHeader = require('./helpers/dynamicModuleRegistryHeader');
  }
  var registeredHelpers = {};
  Object.keys(activeHelpers).forEach(function (helperName) {
    registeredHelpers[helperName] = activeHelpers[helperName](Handlebars);
  });
  return registeredHelpers;
}
module.exports = handlebarsHelpers;
